// extracted by mini-css-extract-plugin
export var courseHeader = "StrapiCourseComparison-module--courseHeader--b0c65";
export var hasTextWeightBold = "StrapiCourseComparison-module--has-text-weight-bold--b030b";
export var isUppercase = "StrapiCourseComparison-module--is-uppercase--ff629";
export var prefix = "StrapiCourseComparison-module--prefix--97a4c";
export var root = "StrapiCourseComparison-module--root--01417";
export var table = "StrapiCourseComparison-module--table--0d18d";
export var tableHeader = "StrapiCourseComparison-module--tableHeader--c505c";